<script>
import Dialog from "../Dialog/index.vue";
import {yyEva} from "yyeva";

export default {
  name: "PreviewVideo",
  components: {Dialog},
  data() {
    return {
      src: undefined,
      visible: true,
      poster: undefined,
      isGift: true,
      player: undefined,
      autoplay: true
    }
  },
  mounted() {
    if (this.isGift) {
      this.autoplay = false
      this.initYYEva()
    }
  },
  watch: {
    visible(val) {
      if (!val && this.isGift) {
        this.destroyPlayer()
      }
    }
  },
  methods: {
    async initYYEva() {
      this.$nextTick(async () => {
        await uni.showLoading({
          title: ""
        })
        this.player = await yyEva({
          container: document.querySelector(".preview-yyEva"),
          alphaDirection: "right",
          mode: "Fill",
          useMetaData: true,
          loop: true,
          useFrameCache: true,
          useVideoDBCache: true,
          mute: false,
          forceBlob: false,
          showVideo: false,
          showPlayerInfo: false,
          useAccurate: true,
          renderType: "canvas2d",
          videoUrl: this.src,
        })
        await uni.hideLoading()
        this.player.start()
        this.player.video.play()
        this.player.video.muted = false
      })
    },
    openMuted() {
      const video = document.querySelector('.preview-video video')
      if (video) {
        video.muted = false
      }
    },
    close() {
      uni.hideLoading()
      this.visible = false
    },
    destroyPlayer() {
      if (this.player) {
        this.player.video.muted = true
        this.player.video.remove()
        this.player.destroy()
      }
    },
  },
  beforeDestroy() {
    this.destroyPlayer()
  },
}
</script>

<template>
  <Dialog v-model='visible'>
    <view @click='close' :class='["preview-yyEva", isGift ? "": "not"]' v-if='isGift'></view>
    <video v-else @play='openMuted' :poster='poster' :show-fullscreen-btn='false'
           class="preview-video" :src="src"
           controls="controls" :autoplay="autoplay" loop='loop' muted object-fit='cover' playsinline/>
  </Dialog>
</template>

<style scoped lang="scss" scoped>
.preview-video {
  width: 100vw;
  height: 80vh;
}

.preview-yyEva {
  width: calc(100vh * (750 / 1624)); /* 动态计算宽度 */
  height: 100vh;
  max-width: 100vw;
  aspect-ratio: 750/1624;
  margin: 0 auto;

  &.not {
    display: none;
  }
}
</style>
